// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Format = require("date-fns/format").default;
var AddDays = require("date-fns/addDays").default;
var IsAfter = require("date-fns/isAfter").default;
var SetDate = require("date-fns/setDate").default;
var SubDays = require("date-fns/subDays").default;
var AddWeeks = require("date-fns/addWeeks").default;
var SetHours = require("date-fns/setHours").default;
var AddMonths = require("date-fns/addMonths").default;
var AddMinutes = require("date-fns/addMinutes").default;
var SetMinutes = require("date-fns/setMinutes").default;
var LastDayOfWeek = require("date-fns/lastDayOfWeek").default;
var LastDayOfMonth = require("date-fns/lastDayOfMonth").default;
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../bs-utils/src/DeccoUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var SmartcutIds$SmartcutsMacros = require("./SmartcutIds.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var PlaybackOptions$SmartcutsMacros = require("./PlaybackOptions.bs.js");
var SmartcutExecution$SmartcutsMacros = require("./SmartcutExecution.bs.js");

var _map = {"ACTIVE":"ACTIVE","PAUSED":"PAUSED","ARCHIVED":"ARCHIVED"};

function tToJs(param) {
  return param;
}

function tFromJs(param) {
  return _map[param];
}

var Status = DeccoUtils$SmartcutsMacros.MakePolymorphicWithDeccoFns({
      typeName: "ScheduledTrigger.Status.t",
      tToJs: tToJs,
      tFromJs: tFromJs
    });

function hourMinute_encode(v) {
  return [
          Decco.intToJson(v[0]),
          Decco.intToJson(v[1])
        ];
}

function hourMinute_decode(v) {
  var match = Js_json.classify(v);
  if (typeof match === "number") {
    return Decco.error(undefined, "Not a tuple", v);
  }
  if (match.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a tuple", v);
  }
  var match$1 = match._0;
  if (match$1.length !== 2) {
    return Decco.error(undefined, "Incorrect cardinality", v);
  }
  var v0 = match$1[0];
  var v1 = match$1[1];
  var match$2 = Decco.intFromJson(v0);
  var match$3 = Decco.intFromJson(v1);
  if (match$2.TAG === /* Ok */0) {
    if (match$3.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: [
                match$2._0,
                match$3._0
              ]
            };
    }
    var e = match$3._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[1]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = match$2._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: "[0]" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function dayOfWeek_encode(v) {
  switch (v) {
    case /* Sunday */0 :
        return ["Sunday"];
    case /* Monday */1 :
        return ["Monday"];
    case /* Tuesday */2 :
        return ["Tuesday"];
    case /* Wednesday */3 :
        return ["Wednesday"];
    case /* Thursday */4 :
        return ["Thursday"];
    case /* Friday */5 :
        return ["Friday"];
    case /* Saturday */6 :
        return ["Saturday"];
    
  }
}

function dayOfWeek_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Friday" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Friday */5
                  };
          }
      case "Monday" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Monday */1
                  };
          }
      case "Saturday" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Saturday */6
                  };
          }
      case "Sunday" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Sunday */0
                  };
          }
      case "Thursday" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Thursday */4
                  };
          }
      case "Tuesday" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Tuesday */2
                  };
          }
      case "Wednesday" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Wednesday */3
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function schedulePeriod_encode(v) {
  switch (v.TAG | 0) {
    case /* EveryDay */0 :
        return [
                "EveryDay",
                hourMinute_encode(v._0)
              ];
    case /* EveryWeek */1 :
        return [
                "EveryWeek",
                dayOfWeek_encode(v._0),
                hourMinute_encode(v._1)
              ];
    case /* EveryMonth */2 :
        return [
                "EveryMonth",
                Decco.intToJson(v._0),
                hourMinute_encode(v._1)
              ];
    case /* EveryLastDayOfTheMonth */3 :
        return [
                "EveryLastDayOfTheMonth",
                hourMinute_encode(v._0)
              ];
    
  }
}

function schedulePeriod_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "EveryDay" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = hourMinute_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* EveryDay */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "EveryLastDayOfTheMonth" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = hourMinute_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* EveryLastDayOfTheMonth */3,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "EveryMonth" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = hourMinute_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* EveryMonth */2,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$2 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "EveryWeek" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = dayOfWeek_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = hourMinute_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* EveryWeek */1,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$4 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function schedulePeriodHourMinuteGet(schedulePeriod) {
  switch (schedulePeriod.TAG | 0) {
    case /* EveryWeek */1 :
    case /* EveryMonth */2 :
        return schedulePeriod._1;
    case /* EveryDay */0 :
    case /* EveryLastDayOfTheMonth */3 :
        return schedulePeriod._0;
    
  }
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "installedSmartcutId",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
              ],
              [
                "status",
                Curry._1(Status.t_encode, v.status)
              ],
              [
                "schedulePeriod",
                DeccoUtils$SmartcutsMacros.decodable_encode(schedulePeriod_encode, v.schedulePeriod)
              ],
              [
                "dataSource",
                DeccoUtils$SmartcutsMacros.decodable_encode(SmartcutExecution$SmartcutsMacros.ExecutionSet.dataSource_encode, v.dataSource)
              ],
              [
                "playbackOptions",
                DeccoUtils$SmartcutsMacros.decodable_encode(PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode, v.playbackOptions)
              ],
              [
                "commandSchemaVersion",
                Decco.stringToJson(v.commandSchemaVersion)
              ],
              [
                "playbackOptionsSchemaVersion",
                Decco.stringToJson(v.playbackOptionsSchemaVersion)
              ],
              [
                "maybeLastCheckedAt",
                Decco.optionToJson(Decco.floatToJson, v.maybeLastCheckedAt)
              ],
              [
                "updatedAt",
                Decco.floatToJson(v.updatedAt)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
    if (installedSmartcutId.TAG === /* Ok */0) {
      var status = Curry._1(Status.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
      if (status.TAG === /* Ok */0) {
        var schedulePeriod = DeccoUtils$SmartcutsMacros.decodable_decode(schedulePeriod_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "schedulePeriod"), null));
        if (schedulePeriod.TAG === /* Ok */0) {
          var dataSource = DeccoUtils$SmartcutsMacros.decodable_decode(SmartcutExecution$SmartcutsMacros.ExecutionSet.dataSource_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataSource"), null));
          if (dataSource.TAG === /* Ok */0) {
            var playbackOptions = DeccoUtils$SmartcutsMacros.decodable_decode(PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackOptions"), null));
            if (playbackOptions.TAG === /* Ok */0) {
              var commandSchemaVersion = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandSchemaVersion"), null));
              if (commandSchemaVersion.TAG === /* Ok */0) {
                var playbackOptionsSchemaVersion = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackOptionsSchemaVersion"), null));
                if (playbackOptionsSchemaVersion.TAG === /* Ok */0) {
                  var maybeLastCheckedAt = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeLastCheckedAt"), null));
                  if (maybeLastCheckedAt.TAG === /* Ok */0) {
                    var updatedAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedAt"), null));
                    if (updatedAt.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: {
                                id: id._0,
                                installedSmartcutId: installedSmartcutId._0,
                                status: status._0,
                                schedulePeriod: schedulePeriod._0,
                                dataSource: dataSource._0,
                                playbackOptions: playbackOptions._0,
                                commandSchemaVersion: commandSchemaVersion._0,
                                playbackOptionsSchemaVersion: playbackOptionsSchemaVersion._0,
                                maybeLastCheckedAt: maybeLastCheckedAt._0,
                                updatedAt: updatedAt._0
                              }
                            };
                    }
                    var e = updatedAt._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".updatedAt" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = maybeLastCheckedAt._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".maybeLastCheckedAt" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }
                var e$2 = playbackOptionsSchemaVersion._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".playbackOptionsSchemaVersion" + e$2.path,
                          message: e$2.message,
                          value: e$2.value
                        }
                      };
              }
              var e$3 = commandSchemaVersion._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".commandSchemaVersion" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                      }
                    };
            }
            var e$4 = playbackOptions._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".playbackOptions" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = dataSource._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".dataSource" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
        }
        var e$6 = schedulePeriod._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".schedulePeriod" + e$6.path,
                  message: e$6.message,
                  value: e$6.value
                }
              };
      }
      var e$7 = status._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".status" + e$7.path,
                message: e$7.message,
                value: e$7.value
              }
            };
    }
    var e$8 = installedSmartcutId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".installedSmartcutId" + e$8.path,
              message: e$8.message,
              value: e$8.value
            }
          };
  }
  var e$9 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$9.path,
            message: e$9.message,
            value: e$9.value
          }
        };
}

function make(id, installedSmartcutId, status, schedulePeriodSerialized, dataSourceSerialized, playbackOptionsSerialized, playbackOptionsSchemaVersion, commandSchemaVersion, maybeLastCheckedAt, updatedAt) {
  var decoded = schedulePeriod_decode(JSON.parse(schedulePeriodSerialized));
  var tmp;
  if (decoded.TAG === /* Ok */0) {
    tmp = {
      TAG: /* Decoded */0,
      _0: decoded._0
    };
  } else {
    console.error(decoded._0);
    tmp = {
      TAG: /* UnableToDecode */1,
      _0: JSON.parse(schedulePeriodSerialized)
    };
  }
  var decoded$1 = SmartcutExecution$SmartcutsMacros.ExecutionSet.dataSource_decode(JSON.parse(dataSourceSerialized));
  var tmp$1;
  if (decoded$1.TAG === /* Ok */0) {
    tmp$1 = {
      TAG: /* Decoded */0,
      _0: decoded$1._0
    };
  } else {
    console.error(decoded$1._0);
    tmp$1 = {
      TAG: /* UnableToDecode */1,
      _0: JSON.parse(dataSourceSerialized)
    };
  }
  var tmp$2;
  if (playbackOptionsSchemaVersion !== PlaybackOptions$SmartcutsMacros.schemaVersion) {
    tmp$2 = {
      TAG: /* UnableToDecode */1,
      _0: JSON.parse(playbackOptionsSerialized)
    };
  } else {
    var decoded$2 = PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode(JSON.parse(playbackOptionsSerialized));
    if (decoded$2.TAG === /* Ok */0) {
      tmp$2 = {
        TAG: /* Decoded */0,
        _0: decoded$2._0
      };
    } else {
      console.error(decoded$2._0);
      tmp$2 = {
        TAG: /* UnableToDecode */1,
        _0: JSON.parse(playbackOptionsSerialized)
      };
    }
  }
  return {
          id: id,
          installedSmartcutId: installedSmartcutId,
          status: status,
          schedulePeriod: tmp,
          dataSource: tmp$1,
          playbackOptions: tmp$2,
          commandSchemaVersion: commandSchemaVersion,
          playbackOptionsSchemaVersion: playbackOptionsSchemaVersion,
          maybeLastCheckedAt: maybeLastCheckedAt,
          updatedAt: updatedAt
        };
}

var LoadedScheduledTrigger = {
  t_encode: t_encode,
  t_decode: t_decode,
  make: make
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "installedSmartcutId",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
              ],
              [
                "schedulePeriod",
                schedulePeriod_encode(v.schedulePeriod)
              ],
              [
                "updatedAt",
                Decco.floatToJson(v.updatedAt)
              ],
              [
                "dataSource",
                SmartcutExecution$SmartcutsMacros.ExecutionSet.dataSource_encode(v.dataSource)
              ],
              [
                "status",
                Curry._1(Status.t_encode, v.status)
              ],
              [
                "userSpecifiedPlaybackOptions",
                PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode(v.userSpecifiedPlaybackOptions)
              ],
              [
                "maybeLastCheckedAt",
                Decco.optionToJson(Decco.floatToJson, v.maybeLastCheckedAt)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
    if (installedSmartcutId.TAG === /* Ok */0) {
      var schedulePeriod = schedulePeriod_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "schedulePeriod"), null));
      if (schedulePeriod.TAG === /* Ok */0) {
        var updatedAt = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "updatedAt"), null));
        if (updatedAt.TAG === /* Ok */0) {
          var dataSource = SmartcutExecution$SmartcutsMacros.ExecutionSet.dataSource_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dataSource"), null));
          if (dataSource.TAG === /* Ok */0) {
            var status = Curry._1(Status.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
            if (status.TAG === /* Ok */0) {
              var userSpecifiedPlaybackOptions = PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "userSpecifiedPlaybackOptions"), null));
              if (userSpecifiedPlaybackOptions.TAG === /* Ok */0) {
                var maybeLastCheckedAt = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeLastCheckedAt"), null));
                if (maybeLastCheckedAt.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            id: id._0,
                            installedSmartcutId: installedSmartcutId._0,
                            schedulePeriod: schedulePeriod._0,
                            updatedAt: updatedAt._0,
                            dataSource: dataSource._0,
                            status: status._0,
                            userSpecifiedPlaybackOptions: userSpecifiedPlaybackOptions._0,
                            maybeLastCheckedAt: maybeLastCheckedAt._0
                          }
                        };
                }
                var e = maybeLastCheckedAt._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".maybeLastCheckedAt" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = userSpecifiedPlaybackOptions._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".userSpecifiedPlaybackOptions" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = status._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".status" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = dataSource._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".dataSource" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = updatedAt._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".updatedAt" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = schedulePeriod._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".schedulePeriod" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = installedSmartcutId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".installedSmartcutId" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function fromLoadedScheduledTrigger(loadedTrigger) {
  var match = loadedTrigger.schedulePeriod;
  var match$1 = loadedTrigger.dataSource;
  var match$2 = loadedTrigger.playbackOptions;
  if (match.TAG === /* Decoded */0 && match$1.TAG === /* Decoded */0 && match$2.TAG === /* Decoded */0) {
    return {
            id: loadedTrigger.id,
            installedSmartcutId: loadedTrigger.installedSmartcutId,
            schedulePeriod: match._0,
            updatedAt: loadedTrigger.updatedAt,
            dataSource: match$1._0,
            status: loadedTrigger.status,
            userSpecifiedPlaybackOptions: match$2._0,
            maybeLastCheckedAt: loadedTrigger.maybeLastCheckedAt
          };
  }
  
}

var weekdays = [
  /* Sunday */0,
  /* Monday */1,
  /* Tuesday */2,
  /* Wednesday */3,
  /* Thursday */4,
  /* Friday */5,
  /* Saturday */6
];

function dayOfWeekToString(v) {
  switch (v) {
    case /* Sunday */0 :
        return "Sunday";
    case /* Monday */1 :
        return "Monday";
    case /* Tuesday */2 :
        return "Tuesday";
    case /* Wednesday */3 :
        return "Wednesday";
    case /* Thursday */4 :
        return "Thursday";
    case /* Friday */5 :
        return "Friday";
    case /* Saturday */6 :
        return "Saturday";
    
  }
}

function maybeDayOfWeekFromString(stringValue) {
  return ArrayUtils$SmartcutsMacros.firstMatch((function (dayOfWeek) {
                return stringValue === dayOfWeekToString(dayOfWeek);
              }), weekdays);
}

function nextAvailableScheduleTime(maybeLastCheckedAt, param) {
  return AddMinutes(OptionUtils$SmartcutsMacros.withDefault(new Date(), maybeLastCheckedAt), 2);
}

function nextScheduledTimeForSchedulePeriod(maybeLastCheckedAt, schedulePeriod) {
  var nextAvailableTime = nextAvailableScheduleTime(maybeLastCheckedAt, undefined);
  switch (schedulePeriod.TAG | 0) {
    case /* EveryDay */0 :
        var match = schedulePeriod._0;
        var nextDateTime = SetMinutes(SetHours(nextAvailableTime, match[0]), match[1]);
        if (IsAfter(nextDateTime, nextAvailableTime)) {
          return nextDateTime;
        } else {
          return AddDays(nextDateTime, 1);
        }
    case /* EveryWeek */1 :
        var match$1 = schedulePeriod._1;
        var nextDateTime$1 = SetMinutes(SetHours(SubDays(LastDayOfWeek(nextAvailableTime), 6 - weekdays.indexOf(schedulePeriod._0) | 0), match$1[0]), match$1[1]);
        if (IsAfter(nextDateTime$1, nextAvailableTime)) {
          return nextDateTime$1;
        } else {
          return AddWeeks(nextDateTime$1, 1);
        }
    case /* EveryMonth */2 :
        var match$2 = schedulePeriod._1;
        var nextDateTime$2 = SetMinutes(SetHours(SetDate(nextAvailableTime, schedulePeriod._0), match$2[0]), match$2[1]);
        if (IsAfter(nextDateTime$2, nextAvailableTime)) {
          return nextDateTime$2;
        } else {
          return AddMonths(nextDateTime$2, 1);
        }
    case /* EveryLastDayOfTheMonth */3 :
        var match$3 = schedulePeriod._0;
        var nextDateTime$3 = SetMinutes(SetHours(LastDayOfMonth(nextAvailableTime), match$3[0]), match$3[1]);
        if (IsAfter(nextDateTime$3, nextAvailableTime)) {
          return nextDateTime$3;
        } else {
          return AddMonths(nextDateTime$3, 1);
        }
    
  }
}

function nextScheduledTime(param) {
  var arg = OptionUtils$SmartcutsMacros.map(param.maybeLastCheckedAt, (function (prim) {
          return new Date(prim);
        }));
  return nextScheduledTimeForSchedulePeriod(Caml_option.some((function (param) {
                      return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                    })(new Date(param.updatedAt))), param.schedulePeriod);
}

function maybePeriodInMinutes(param) {
  switch (param.schedulePeriod.TAG | 0) {
    case /* EveryDay */0 :
        return 1440;
    case /* EveryWeek */1 :
        return 10080;
    case /* EveryMonth */2 :
    case /* EveryLastDayOfTheMonth */3 :
        return ;
    
  }
}

function maybeUpdateNextScheduledTime(param) {
  var schedulePeriod = param.schedulePeriod;
  var now = new Date();
  switch (schedulePeriod.TAG | 0) {
    case /* EveryDay */0 :
    case /* EveryWeek */1 :
        return ;
    case /* EveryMonth */2 :
        var match = schedulePeriod._1;
        return SetMinutes(SetHours(SetDate(AddMonths(now, 1), schedulePeriod._0), match[0]), match[1]).getTime();
    case /* EveryLastDayOfTheMonth */3 :
        var match$1 = schedulePeriod._0;
        return SetMinutes(SetHours(LastDayOfMonth(AddMonths(now, 1)), match$1[0]), match$1[1]).getTime();
    
  }
}

function toAlarmCreateInfo(scheduledTrigger) {
  var when_ = nextScheduledTime(scheduledTrigger).getTime();
  var periodInMinutes = maybePeriodInMinutes(scheduledTrigger);
  var tmp = {
    when: when_
  };
  if (periodInMinutes !== undefined) {
    tmp.periodInMinutes = Caml_option.valFromOption(periodInMinutes);
  }
  return tmp;
}

function createBrowserAlarm(scheduledTrigger) {
  browser.alarms.create(scheduledTrigger.id, toAlarmCreateInfo(scheduledTrigger));
  
}

function humanizeHourMinute(param) {
  return Format(SetMinutes(SetHours(new Date(), param[0]), param[1]), "hh:mm a");
}

function humanizeSchedulePeriod(v) {
  switch (v.TAG | 0) {
    case /* EveryDay */0 :
        return "Every day at " + humanizeHourMinute(v._0);
    case /* EveryWeek */1 :
        return "Every week on " + (dayOfWeekToString(v._0) + (" at " + humanizeHourMinute(v._1)));
    case /* EveryMonth */2 :
        return "Every month on " + (StringUtils$SmartcutsMacros.withOrd(v._0) + (" at " + humanizeHourMinute(v._1)));
    case /* EveryLastDayOfTheMonth */3 :
        return "The last day of every  month at " + humanizeHourMinute(v._0);
    
  }
}

var allSteps = [
  /* ScheduledDays */0,
  /* NTimesInADay */1,
  /* ScheduledTimes */2
];

function configStepToString(v) {
  switch (v) {
    case /* ScheduledDays */0 :
        return "ScheduledDays";
    case /* NTimesInADay */1 :
        return "NTimesInADay";
    case /* ScheduledTimes */2 :
        return "ScheduledTimes";
    
  }
}

function nTimesInADayToString(v) {
  switch (v) {
    case /* Once */0 :
        return "Once";
    case /* ThreeTimes */1 :
        return "Three times";
    case /* ManyTimes */2 :
        return "X times (you can customize)";
    
  }
}

function scheduledDaysToString(scheduledDays) {
  return Belt_Array.map(scheduledDays, dayOfWeekToString);
}

function scheduledTimesToString(scheduledTimes) {
  return Belt_Array.map(scheduledTimes, humanizeHourMinute);
}

var allNTimesInADay = [
  /* Once */0,
  /* ThreeTimes */1,
  /* ManyTimes */2
];

var Idiomatic = {
  allSteps: allSteps,
  configStepToString: configStepToString,
  nTimesInADayToString: nTimesInADayToString,
  scheduledDaysToString: scheduledDaysToString,
  scheduledTimesToString: scheduledTimesToString,
  allNTimesInADay: allNTimesInADay
};

exports.Status = Status;
exports.hourMinute_encode = hourMinute_encode;
exports.hourMinute_decode = hourMinute_decode;
exports.dayOfWeek_encode = dayOfWeek_encode;
exports.dayOfWeek_decode = dayOfWeek_decode;
exports.schedulePeriod_encode = schedulePeriod_encode;
exports.schedulePeriod_decode = schedulePeriod_decode;
exports.schedulePeriodHourMinuteGet = schedulePeriodHourMinuteGet;
exports.LoadedScheduledTrigger = LoadedScheduledTrigger;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.fromLoadedScheduledTrigger = fromLoadedScheduledTrigger;
exports.weekdays = weekdays;
exports.dayOfWeekToString = dayOfWeekToString;
exports.maybeDayOfWeekFromString = maybeDayOfWeekFromString;
exports.nextScheduledTimeForSchedulePeriod = nextScheduledTimeForSchedulePeriod;
exports.nextScheduledTime = nextScheduledTime;
exports.maybePeriodInMinutes = maybePeriodInMinutes;
exports.maybeUpdateNextScheduledTime = maybeUpdateNextScheduledTime;
exports.createBrowserAlarm = createBrowserAlarm;
exports.humanizeHourMinute = humanizeHourMinute;
exports.humanizeSchedulePeriod = humanizeSchedulePeriod;
exports.Idiomatic = Idiomatic;
/* Status Not a pure module */
